import { render, staticRenderFns } from "./deleteIconDialog.vue?vue&type=template&id=48f3cf9a&scoped=true&"
import script from "./deleteIconDialog.vue?vue&type=script&lang=js&"
export * from "./deleteIconDialog.vue?vue&type=script&lang=js&"
import style0 from "./deleteIconDialog.vue?vue&type=style&index=0&id=48f3cf9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f3cf9a",
  null
  
)

export default component.exports